import { 
  doc, 
  setDoc, 
  getDoc, 
  updateDoc,
  collection,
  query,
  where,
  getDocs,
  serverTimestamp
} from 'firebase/firestore';
import { db } from '../config/firebase';

const USERS_COLLECTION = 'users';

// Cache for user profiles to prevent unnecessary reads
const profileCache = new Map();

export const createUserProfile = async (userId, userData) => {
  try {
    const userRef = doc(db, USERS_COLLECTION, userId);
    const timestamp = serverTimestamp();
    await setDoc(userRef, {
      ...userData,
      createdAt: timestamp,
      updatedAt: timestamp,
    });
    // Update cache
    profileCache.set(userId, { ...userData, createdAt: timestamp, updatedAt: timestamp });
    return true;
  } catch (error) {
    console.error('Error creating user profile:', error);
    throw error;
  }
};

export const getUserProfile = async (userId) => {
  try {
    console.log('Getting user profile for ID:', userId);
    
    // Check cache first
    if (profileCache.has(userId)) {
      console.log('Found user profile in cache:', profileCache.get(userId));
      return profileCache.get(userId);
    }

    const userRef = doc(db, USERS_COLLECTION, userId);
    console.log('Fetching from Firestore, collection:', USERS_COLLECTION, 'document:', userId);
    
    const userSnap = await getDoc(userRef);
    console.log('Firestore response - exists:', userSnap.exists());
    
    if (userSnap.exists()) {
      const data = userSnap.data();
      console.log('User profile data from Firestore:', data);
      // Update cache
      profileCache.set(userId, data);
      return data;
    }
    
    console.log('User profile does not exist in Firestore');
    return null;
  } catch (error) {
    console.error('Error getting user profile:', error);
    throw error;
  }
};

export const updateUserProfile = async (userId, updates) => {
  const userRef = doc(db, USERS_COLLECTION, userId);
  await updateDoc(userRef, updates);
};

export const checkEaIdExists = async (eaId) => {
  try {
    const usersRef = collection(db, USERS_COLLECTION);
    const q = query(usersRef, where('eaId', '==', eaId));
    const querySnapshot = await getDocs(q);
    return !querySnapshot.empty;
  } catch (error) {
    console.error('Error checking EA ID:', error);
    throw error;
  }
};

// Clear cache when user logs out
export const clearProfileCache = () => {
  profileCache.clear();
}; 